import { render, staticRenderFns } from "./NewLister.vue?vue&type=template&id=dd895c56"
import script from "./NewLister.vue?vue&type=script&lang=js"
export * from "./NewLister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports